import jwt_decode from "jwt-decode";
import { Profiles } from "src/app/utils/profiles";
import { Solutions } from "./utils/solutions";

export function cloneObject<T>(originalObject: T): T {
  return Object.assign({}, originalObject);
}

export function isEmptyObject(obj: any): boolean {
  return obj && Object.keys(obj).length === 0;
}

export function getToken(tokenKey: string) {
  if (!localStorage.getItem(tokenKey)) {
    return "";
  }
  return JSON.parse(localStorage.getItem(tokenKey) as string);
}

export function isMobile(): boolean {
  return /android|webos|iphone|ipad|ipod|blackberry|windows phone/.test(
    navigator.userAgent.toLowerCase()
  );
}
export class Menus {
  private static readonly REGISTAR = "/registar";
  static deniedMenusSuperUser = [Menus.REGISTAR];
}

export class User {
  static get isLoading(): boolean {
    return this._isLoading;
  }
  static set isLoading(isLoading: boolean) {
    this._isLoading = isLoading;
  }


  //dashboard Tools Management List
  public static accessDashboardToolsManagementList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Dashboard Industrial Vending List
  public static accessDashboardIndustrialVendingList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Dashboard Industrial Vending Tools Management List
  public static accessDashboardIndustrialVendingToolsManagementList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Alterar Password
  public static accessAlterarPasswordEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Parametros do Sistema
  public static accessAlterarParametrosSistemaEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Entidades
  public static accessEntidadesList = [
    Profiles.AdministradorGeral,
    //Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessEntidadesCreate = [
    Profiles.AdministradorGeral,
    //Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessEntidadesDelete = [
    Profiles.AdministradorGeral,
    //Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessEntidadesEdit = [
    Profiles.AdministradorGeral,
    //Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Locais
  public static accessLocaisList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessLocaisCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessLocaisDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessLocaisEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Armários
  public static accessArmariosList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessArmariosCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessArmariosDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessArmariosEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Equipas
  public static accessEquipasList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];


  public static accessEquipasCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessEquipasDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessEquipasEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessEquipasEditTeamsFormToolsFuncao = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessEquipasEditTeamsFormToolsSolucao = [
    //Solutions.IndustrialVending,
    Solutions.ToolManegament,
    Solutions.IndustrialVendingToolManagement
  ];

  public static accessEquipasEditTeamsFormIVFuncao = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessEquipasEditTeamsFormIVSolucao = [
    Solutions.IndustrialVending,
    //Solutions.ToolManegament,
    Solutions.IndustrialVendingToolManagement
  ];

  //Utilizadores
  public static accessUserList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessUserCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessUserDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessUserEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Tipo de Ferramentas
  public static accessTipoFerramentasList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessTipoFerramentasCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessTipoFerramentasDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];


  public static accessTipoFerramentasEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];


  //Subtipode de Ferramentas
  public static accessSubTipoFerramentasList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];


  public static accessSubTipoFerramentasCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessSubTipoFerramentasDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessSubTipoFerramentasEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Ferramentas
  public static accessFerramentasList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];


  public static accessFerramentasCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessFerramentasDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];


  public static accessFerramentasEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //cantro de custos
  public static accessCentroCustosList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessCentroCustosCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    // Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessCentroCustosDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    // Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessCentroCustosEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    // Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Artigos
  public static accessArtigosList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessArtigosCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    // Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessArtigosDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    // Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];
  public static accessArtigosEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    // Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];
  public static accessArtigosUpload = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Associação de Artigos Por Equipa
  public static accessAssociacaoArtigosPorEquipaList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessAssociacaoArtigosPorEquipaEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //associação de Artigos Por Armário
  public static accessAssociacaoArtigosPorArmarioList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessAssociacaoArtigosPorArmarioEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Inventário
  public static accessInventarioList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //consumo
  public static accessConsumoList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Movimentos Tool Management
  public static accessMovimentosToolManagementList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    Profiles.RespFerramentas,
    Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Movimentos Industrail Vending
  public static accessMovimentosIndustrialVendingList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    Profiles.Manutencao,
    Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Alertas
  public static accessAlertasList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessAlertasEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  //Anomalias 
  public static accessAnomaliasList = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessAnomaliasEdit = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessAnomaliasCreate = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];

  public static accessAnomaliasDelete = [
    Profiles.AdministradorGeral,
    Profiles.Administrador,
    //Profiles.Diretor,
    //Profiles.Supervisor,
    //Profiles.RespFerramentas,
    //Profiles.Manutencao,
    //Profiles.Repositor,
    //Profiles.Limpeza,
    //Profiles.Colaborador
  ];







  //Dashboard Tools Management
  static canDashboardToolsManagementList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessDashboardToolsManagementList.indexOf(idFuncao) >= 0;
  }

  //Dashboard Industrial Vending
  static canDashboardIndustrialVendingList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessDashboardIndustrialVendingList.indexOf(idFuncao) >= 0;
  }

  //Dashboard Industrial Vending Tools Management
  static canDashboardIndustrialVendingToolsManagementList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessDashboardIndustrialVendingToolsManagementList.indexOf(idFuncao) >= 0;
  }

  //Alterar Password
  static canAlterarPasswordEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAlterarPasswordEdit.indexOf(idFuncao) >= 0;
  }

  //Parametros do Sistema
  static canAlterarParametrosSistemaEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAlterarParametrosSistemaEdit.indexOf(idFuncao) >= 0;
  }

  //Entidades
  static canEntidadesList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessEntidadesList.indexOf(idFuncao) >= 0;
  }

  static canEntidadesCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessEntidadesCreate.indexOf(idFuncao) >= 0;
  }

  static canEntidadesDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessEntidadesDelete.indexOf(idFuncao) >= 0;
  }

  static canEntidadesEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessEntidadesEdit.indexOf(idFuncao) >= 0;
  }

  //Locais
  static canLocaisList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessLocaisList.indexOf(idFuncao) >= 0;
  }

  static canLocaisCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessLocaisCreate.indexOf(idFuncao) >= 0;
  }

  static canLocaisDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessLocaisDelete.indexOf(idFuncao) >= 0;
  }

  static canLocaisEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessLocaisEdit.indexOf(idFuncao) >= 0;
  }

  //Armarios
  static canArmariosList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessArmariosList.indexOf(idFuncao) >= 0;
  }

  static canArmariosCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessArmariosCreate.indexOf(idFuncao) >= 0;
  }

  static canArmariosDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessArmariosDelete.indexOf(idFuncao) >= 0;
  }

  static canArmariosEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessArmariosEdit.indexOf(idFuncao) >= 0;
  }


  //Equipas
  static canEquipasList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessEquipasList.indexOf(idFuncao) >= 0;
  }

  static canEquipasCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessEquipasCreate.indexOf(idFuncao) >= 0;
  }

  static canEquipasDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessEquipasDelete.indexOf(idFuncao) >= 0;
  }

  static canEquipasEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessEquipasEdit.indexOf(idFuncao) >= 0;
  }

  // for tool management
  static canEquipasEditTeamsFormTools(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    var idSolucao = user.IDSolucaoEntidade;
    return this.accessEquipasEditTeamsFormToolsFuncao.indexOf(idFuncao) >= 0 && this.accessEquipasEditTeamsFormToolsSolucao.indexOf(idSolucao) >= 0 || idSolucao == 0;
  }

  // for industrial vending
  static canEquipasEditTeamsFormIV(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    var idSolucao = user.IDSolucaoEntidade;
    return this.accessEquipasEditTeamsFormIVFuncao.indexOf(idFuncao) >= 0 && this.accessEquipasEditTeamsFormIVSolucao.indexOf(idSolucao) >= 0 || idSolucao == 0;
  }


  //Utilizadores
  static canUserList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessUserList.indexOf(idFuncao) >= 0;
  }

  static canUserCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessUserCreate.indexOf(idFuncao) >= 0;
  }

  static canUserDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessUserDelete.indexOf(idFuncao) >= 0;
  }

  static canUserEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessUserEdit.indexOf(idFuncao) >= 0;
  }

  //Tipo de Ferramentas
  static canTipoFerramentasList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessTipoFerramentasList.indexOf(idFuncao) >= 0;
  }

  static canTipoFerramentasCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessTipoFerramentasCreate.indexOf(idFuncao) >= 0;
  }

  static canTipoFerramentasDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessTipoFerramentasDelete.indexOf(idFuncao) >= 0;
  }

  static canTipoFerramentasEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessTipoFerramentasEdit.indexOf(idFuncao) >= 0;
  }

  //Subtipo de Ferramentas
  static canSubTipoFerramentasList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessSubTipoFerramentasList.indexOf(idFuncao) >= 0;
  }

  static canSubTipoFerramentasCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessSubTipoFerramentasCreate.indexOf(idFuncao) >= 0;
  }

  static canSubTipoFerramentasDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessSubTipoFerramentasDelete.indexOf(idFuncao) >= 0;
  }

  static canSubTipoFerramentasEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessSubTipoFerramentasEdit.indexOf(idFuncao) >= 0;
  }

  //Ferramentas
  static canFerramentasList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessFerramentasList.indexOf(idFuncao) >= 0;
  }

  static canFerramentasCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessFerramentasCreate.indexOf(idFuncao) >= 0;
  }

  static canFerramentasDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessFerramentasDelete.indexOf(idFuncao) >= 0;
  }

  static canFerramentasEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessFerramentasEdit.indexOf(idFuncao) >= 0;
  }

  //Centro de Custos
  static canCentroCustosList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessCentroCustosList.indexOf(idFuncao) >= 0;
  }

  static canCentroCustosCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessCentroCustosCreate.indexOf(idFuncao) >= 0;
  }

  static canCentroCustosDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessCentroCustosDelete.indexOf(idFuncao) >= 0;
  }

  static canCentroCustosEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessCentroCustosEdit.indexOf(idFuncao) >= 0;
  }

  //Artigos
  static canArtigosList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessArtigosList.indexOf(idFuncao) >= 0;
  }

  static canArtigosCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessArtigosCreate.indexOf(idFuncao) >= 0;
  }

  static canArtigosDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessArtigosDelete.indexOf(idFuncao) >= 0;
  }

  static canArtigosEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessArtigosEdit.indexOf(idFuncao) >= 0;
  }

  static canArtigosUpload(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessArtigosUpload.indexOf(idFuncao) >= 0;
  }

  //Associação de Artigos Por Equipa
  static canAssociacaoArtigosPorEquipaList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAssociacaoArtigosPorEquipaList.indexOf(idFuncao) >= 0;
  }

  static canAssociacaoArtigosPorEquipaEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAssociacaoArtigosPorEquipaEdit.indexOf(idFuncao) >= 0;
  }

  //Associação de Artigos Por Armário
  static canAssociacaoArtigosPorArmarioList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAssociacaoArtigosPorArmarioList.indexOf(idFuncao) >= 0;
  }

  static canAssociacaoArtigosPorArmarioEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAssociacaoArtigosPorArmarioEdit.indexOf(idFuncao) >= 0;
  }

  //Inventário
  static canInventarioList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessInventarioList.indexOf(idFuncao) >= 0;
  }

  //Consumo
  static canConsumoList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessConsumoList.indexOf(idFuncao) >= 0;
  }

  //Movimentos Tool Management
  static canMovimentosToolManagementList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessMovimentosToolManagementList.indexOf(idFuncao) >= 0;
  }

  //Movimentos Industrial Vending
  static canMovimentosIndustrialVendingList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessMovimentosIndustrialVendingList.indexOf(idFuncao) >= 0;
  }

  //Alertas
  static canAlertasList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAlertasList.indexOf(idFuncao) >= 0;
  }

  static canAlertasEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAlertasEdit.indexOf(idFuncao) >= 0;
  }

  //Anomalias
  static canAnomaliasList(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAnomaliasList.indexOf(idFuncao) >= 0;
  }

  static canAnomaliasEdit(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAnomaliasEdit.indexOf(idFuncao) >= 0;
  }

  static canAnomaliasCreate(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAnomaliasCreate.indexOf(idFuncao) >= 0;
  }

  static canAnomaliasDelete(): boolean {
    var user = User.userInSession();
    var idFuncao = user.IDFuncao;
    return this.accessAnomaliasDelete.indexOf(idFuncao) >= 0;
  }



  private static localStorageItemName = "currentUser";

  private static _isLoading: boolean;

  private static token: string;

  static setTokenLocalStorage(res: string) {
    localStorage.setItem(
      this.localStorageItemName,
      JSON.stringify({ token: res, tokentype: "Baerer" })
    );
  }

  static getTokenLocalStorage(): string {
    return getToken(this.localStorageItemName).token;
  }

  static removeTokenLocalStorage() {
    localStorage.removeItem(this.localStorageItemName);
  }
  static HasValid(): boolean {
    if (this.getTokenLocalStorage()) {
      return true;
    } else {
      return false;
    }
  }

  static saveCurrentRoute(route: string) {
    localStorage.setItem("currentRoute", JSON.stringify({ route }));
  }


  static removeCurrentRouteFromLocalStorage() {
    localStorage.removeItem("currentRoute");
  }

  static saveCurrentUser(user: string) {
    localStorage.setItem("currentUser", JSON.stringify({ username: user }));
  }


  static removeCurrentUserFromLocalStorage() {
    localStorage.removeItem("currentUser");
  }
  static decodePayloadJWT(token: string): any {
    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }



  static userInSession(): any {
    const ss = this.decodePayloadJWT(this.getTokenLocalStorage());
    if (ss) {
      return ss.payload;
    } else {
      return {};
    }
  }
}


export class Lorem {
  static randomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  static randomString(maxStringLenght: number): string {
    const chars =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
    let randomstring = "";
    for (let i = 0; i < maxStringLenght; i++) {
      const rnum = Math.floor(Math.random() * chars.length);
      randomstring += chars.substring(rnum, rnum + 1);
    }
    return randomstring;
  }
}


export class Constants {
  static monthNames = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
}
